module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex height-100"
  }, [_c('div', {
    staticClass: "margin-auto"
  }, [_c('div', {
    staticClass: "half-width margin-auto margin-top-10"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Boletines Mensuales")]), _c('p'), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Esta opcion se encuentra en desarrollo")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-014d10f6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Boletines_Mensuales_View.vue
// module id = 740
// module chunks = 0